import { render, staticRenderFns } from "./tabsItem.vue?vue&type=template&id=273609d0&scoped=true"
import script from "./tabsItem.vue?vue&type=script&lang=js"
export * from "./tabsItem.vue?vue&type=script&lang=js"
import style0 from "./tabsItem.vue?vue&type=style&index=0&id=273609d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273609d0",
  null
  
)

export default component.exports